/**
 * Quick add to cart component
 * 
 * @module quick-add-to-cart
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'quick-add-to-cart';

if(!customElements.get(customElements.component)){

    class quickAddToCart extends HTMLElement {

        /**
         * Quick add to cart component
         * 
         * @constructor
         */
        constructor() {
    
            super();
    
            this.initEvents();
            this.initFocusTrap();
            
            //Dispatching this event inside related-products.js and collection-filters.js
            window.addEventListener('init-quick-add-to-cart', event => {
                this.initEvents();
                this.initFocusTrap();
            });
            
            window.theme.quickAddToCart = this;
        }

        /**
         * Init component events.
         * 
         * @returns {undefined}
         */
        initEvents() {
            this.initOpenEvents();
            this.initCloseEvents();
        }

        /**
         * Init quick add to cart open events
         * 
         * @returns {undefined}
         */
        initOpenEvents() {
            let btnsOpen = document.querySelectorAll('[data-quick-add-to-cart-handle]');

            btnsOpen.forEach(btn => {
                if(!btn.classList.contains('js-active')) {
                    btn.classList.add('js-active');
                    btn.addEventListener('click', event => {
                        event.preventDefault();
                        this.open(btn.dataset.quickAddToCartHandle);
                    });
                }

            });
        }

        /**
         * Open quick add to cart
         * 
         * @param {string} handle Product handle.
         * @returns {undefined}
         */
         open(handle) {

            window.theme.product.loadProduct(handle, true).then(product => {

                //Set product handle
                this.dataset.handle = product.handle;

                let quickAddToCartView = document.querySelector('[data-quick-add-to-cart-container]');

                let content = this.loadContent(product);
                
                quickAddToCartView.innerHTML += content;

                //Product that has more than one variant
                if(product.variants.length > 1) {

                    document.querySelector('body').classList.add('quick-add-to-cart-active');
                    document.querySelector('.quick-add-to-cart__overlay').classList.add('active');
                    this.initCloseEvents();

                    setTimeout(() => {
                        this.classList.add('active');
                        this.setAttribute('aria-hidden', 'false');
                        this.initButtonEvents();
                        this.activeFocusTrap();
                    }, 500);
                }

                //Product that has only one variant
                if(product.variants.length == 1) {

                    setTimeout(() => {

                        this.updateVariantSelector(product.variants[0]);
                        let oneSizeButton = quickAddToCartView.querySelector('[data-one-size]');
                        if(oneSizeButton) oneSizeButton.click();
                        this.triggerButtonMessage();
                        //Close modal
                        this.close();
                    }, 300);
                }
            });
        }


        /**
         * Init button events
         * 
         * @returns {undefined}
         */
         initButtonEvents() {
            this.querySelectorAll('button[data-variant-id]').forEach(btn => {

                btn.addEventListener('click', event => {
    
                    //Get Variant Selected
                    let variant = this.getVariant(event.target.dataset.variantId);
                    this.updateVariantSelector(variant);
                    this.triggerButtonMessage();;
                    //Close modal
                    this.close();
                });
            });
        }

        /**
         * Get variant
         * 
         * @param {integer} variantId Variant Id.
         * @returns {undefined}
         */
        getVariant(variantId) {

            let variant = null;

            this.options.forEach(option => {

                if (option.variantId == variantId) {
                    variant = option.variant;
                }
            });

            return variant;
        }

        /**
         * Update variant selector web component.
         * 
         * @param {object} variant Product variant data.
         * @returns {undefined}
         */
        updateVariantSelector(variant) {

            let variantSelector = this.querySelector('variant-selector[data-handle="' + this.dataset.handle + '"] select');

            if (variantSelector) {

                variantSelector.value = (variant) ? variant.id : '';

                variantSelector.dispatchEvent(new Event("change"));
            }
        }

        /**
         * Get form
         * 
         * @returns {undefined}
         */
        getForm() {
            return this.querySelector('form');
        }

        /**
         * Load quick add to cart content
         * 
         * @param {object} product Product data.
         * @returns {string} HTML code
         */
         loadContent(product) {

            // Product Template -------------------------------------------------
            let content = quickAddToCartTemplate.quick_add_to_cart_content_layout;

            // Product Image -------------------------------------------------
            let productImage = '';

            if(product.images.length > 0) {
                productImage += `<div class="quick-add-to-cart__image"><img src="${product.images[0].src}" alt="${product.images[0].alt}" loading="lazy"/></div>`;
            }

            content = content.replace(/{{productImage}}/g, productImage);

            // Product Title -------------------------------------------------
            content = content.replace(/{{productTitle}}/g, product.title);

            content = content.replaceAll(/{{productUrl}}/g, product.url);

            // Product Price -------------------------------------------------
            let product_price = `<span class="quick-add-to-cart__price-current" data-price>${product.variants[0].price}</span>`;

            if (product.variants[0].compare_at_price > 0) {
                product_price += `<span class="quick-add-to-cart__price-compared" data-compareatprice>${product.variants[0].compare_at_price}</span>`;
            }
            
            content = content.replace(/{{productPrice}}/g, product_price);

            // Product Swatches -------------------------------------------------
            let product_swatches = '<div class="quick-add-to-cart__swatches-div">';
            let productOptions = ['size', 'Size'];

            productOptions.forEach(option => {
                // Save options
                this.options = this.getOptionsList(product, option);
            });

            //Product that has only one variant
            if(product.variants.length == 1) {
                let variant = product.variants[0];
                product_swatches = product_swatches + '<div class="quick-add-to-cart__swatches-div"><div><button class="btn btn-link" data-one-size data-variant-id="'+variant.id+'"></button></div></div>';
            }
            else {
                if(this.options) {

                    this.options.forEach(option => {

                        product_swatches = product_swatches + '<div>';
                        if(option.variant.available) product_swatches = product_swatches + `<button class="btn btn-link" data-variant-id="${option.variantId}" aria-label="Add ${option.optionValue} to bag" data-available="${option.variant.available}">${option.optionValue}</button>`;
                        else product_swatches = product_swatches + `<button class="btn btn-link" data-variant-id="${option.variantId}" aria-label="Add ${option.optionValue} to bag" data-available="${option.variant.available}" disabled>${option.optionValue}</button>`;
                        product_swatches = product_swatches + '</div>';
                    });
                }
            }

            product_swatches = product_swatches + '</div>';

            content = content.replace(/{{productSwatches}}/g, product_swatches);

            // Product Id -------------------------------------------------
            content = content.replace(/{{productId}}/g, product.id);
            
            // Product Handle -------------------------------------------------
            content = content.replace(/{{productHandle}}/g, product.handle);

            content = content.replace(/{{productUrl}}/g, product.url);


            return content;
        }


        /**
         * Get product options
         * 
         * @param {object} product Product data.
         * @param {string} optionName Product option name.
         * @returns {undefined}
         */
        getOptionsList(product, optionName) {
        
            let optionsList = null;

            if (typeof product.options_by_name[optionName] != 'undefined' ) {
        
                optionsList = [];

                let firstOptionAvailable = null,
                    mainOptionIndex = product.options_by_name.Size.option.position;

                product.variants.forEach(variant => {

                    //if (variant.available) {

                        if (!firstOptionAvailable) {
                            firstOptionAvailable = variant;
                        }

                        if (mainOptionIndex == 1 && firstOptionAvailable.option2 == variant.option2 && firstOptionAvailable.option3 == variant.option3) {

                            optionsList.push({
                                variant: variant,
                                variantId: variant.id,
                                optionValue: variant.option1
                            });
                        }

                        if (mainOptionIndex == 2 && firstOptionAvailable.option1 == variant.option1 && firstOptionAvailable.option3 == variant.option3) {

                            optionsList.push({
                                variant: variant,
                                variantId: variant.id,
                                optionValue: variant.option2
                            });
                        }

                        if (mainOptionIndex == 3 && firstOptionAvailable.option1 == variant.option1 && firstOptionAvailable.option2 == variant.option2) {

                            optionsList.push({
                                variant: variant,
                                variantId: variant.id,
                                optionValue: variant.option3
                            });
                        }
                    //}
                });
            }

            return optionsList;
        }

        /**
         * Init quick view open events
         * 
         * @returns {undefined}
         */
        initCloseEvents() {
            this.querySelectorAll('[data-quick-add-to-cart-close]').forEach(element => {
                element.addEventListener('click', event => {
                    event.preventDefault();
                    this.close();
                });
            });
        }

        /**
         * Close quick view
         * 
         * @returns {undefined}
         */
        close() {

            //this.classList.remove('loaded');
            this.classList.remove('active');

            this.disableFocusTrap();
            

            setTimeout(() => {

                //Remove Handle
                this.dataset.handle = '';
                
                //Remove Content
                let content = document.querySelector('.quick-add-to-cart__content');

                if (content) {
                    content.remove();
                    this.setAttribute('aria-hidden', 'true');
                }

                document.querySelector('body').classList.remove('quick-add-to-cart-active');
                
                document.querySelector('.quick-add-to-cart__overlay').classList.remove('active');

            }, 350);
        }

        /**
         * Init quick view focus trap
         * 
         * @returns {undefined}
         */
        initFocusTrap() {
            this.focusTrap = focusTrap.createFocusTrap(this, {});
        }

        /**
         * Disable quick view focus trap
         *  
         * @returns {undefined}
         */
        disableFocusTrap() {
            if (this.focusTrap) {
                this.focusTrap.deactivate();
            }
        }

        /**
         * Ative quick view focus trap
         * 
         * @returns {undefined}
         */
        activeFocusTrap() {
            if (this.focusTrap) {
                this.focusTrap.activate();
            }
        }

        /**
         * Trigger Button Message
         * 
         * @returns {undefined}
         */
        triggerButtonMessage(){
            let quickAddToCart = new CustomEvent('quick-add-to-cart');
            window.dispatchEvent(quickAddToCart);
        }

    }

    customElements.define(customElements.component, quickAddToCart);    
}


